import styled from 'styled-components';
import GoogleLogin from 'react-google-login';
import InputNumber from 'components/common/InputNumber';
import {
  Col,
  Row,
  Form,
  Button,
  Input,
  Select,
  Timeline,
  Drawer,
  Steps,
  Radio,
  DatePicker
} from 'antd';

export const FormTitle = styled.div`
  font-weight: 700;
  padding-bottom: ${p =>
    p.paddingBottom
      ? typeof p.paddingBottom === 'number'
        ? `${p.paddingBottom}px`
        : p.paddingBottom
      : '6px'};
`;

export const MenuItem = styled.div`
  padding: 10px 0;
  font-size: 16px;
  text-align: center;
  flex: 0 1 auto;

  @media (min-width: 768px) {
    padding: 12px 0;
  }
`;

export const StyledUl = styled.ul`
  list-style-type: '-';
  list-style-position: outside;
  margin: 0;
  padding: 0;

  li {
    font-size: 12px;
    padding-left: 5px;
  }
`;

export const StyledNav = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  &:after {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
    width: ${process.env.REACT_APP_MAX_WIDTH}px;
    margin: 0 auto;
    position: fixed;
    background-color: #fff;
    z-index: -1;
    content: '';
  }
`;

export const PaymentFont = styled.span`
  font-size: ${p =>
    p.fontSize
      ? typeof p.fontSize === 'number'
        ? `${p.fontSize}px`
        : p.fontSize
      : '30px'};
  margin: ${p => (p.margin ? '0 9px' : '0')};
  color: #2c2c2e;
`;

export const NextButton = styled(Button)`
  ${p => (p.curved ? 'border-radius: 50px;' : '')}
  transition: all .3s;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  height: ${p =>
    p.height
      ? typeof p.height === 'number'
        ? `${p.height}px`
        : p.height
      : '50px'};
  background-color: #9900a5;
  border-color: #9900a5;
  ${p => (p.step ? `border-radius: ${0}` : '')}
  ${p => (p.halo ? 'box-shadow: 0 5px 8px 0 rgba(255, 102, 0, 0.24);' : '')};

  &.ant-btn-primary:hover,
  &.ant-btn-primary:focus {
    color: #fff;
    background-color: #c654be;
    border-color: #c654be;
  }

  &.ant-btn-primary:hover:not(:disabled),
  &.ant-btn-primary:focus:not(:disabled) {
    ${p => (p.halo ? 'box-shadow: 0 7px 12px 0 rgba(255, 102, 0, 0.24);' : '')}
  }

  &.ant-btn-primary:active,
  &.ant-btn-primary.active {
    color: #fff;
    background-color: #68076d;
    border-color: #68076d;
  }
`;

export const StyledInput = styled(Input)`
  ${p =>
    p.width
      ? typeof p.width === 'number'
        ? `width: ${p.width}px`
        : `width: ${p.width}`
      : ''};
  font-size: ${p =>
    p.fontSize
      ? typeof p.fontSize === 'number'
        ? `${p.fontSize}px`
        : p.fontSize
      : '14px'};
  ${p => (p.curved ? 'border-radius: 50px;' : '')}
  ${p =>
    p.search
      ? `
    color: #2C2C2E;
    background-color: #e3e3e3;
    border-color: #e3e3e3;

    input {
      background-color: #e3e3e3;

      &::placeholder {
        color: rgba(68, 71, 74, .5);
      }

      &:disabled {
        background-color: transparent;
      }
    }
  `
      : ''}
`;

export const StyledPasswordInput = styled(Input.Password)`
  width: 100%;
`;

export const CardImageContainer = styled.div`
  position: absolute;
  width: 24px;
  height: 16px;
  top: 12px;
  left: 11px;
  z-index: 1;
`;

export const CardImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.4s cubic-bezier(0.075, 0.82, 0.165, 1),
    opacity 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),
    -webkit-transform 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
`;

export const StyledButton = styled(Button)`
  ${p => (p.curved ? 'border-radius: 50px;' : '')}
  width: ${p =>
    p.width
      ? typeof p.width === 'number'
        ? `${p.width}px`
        : p.width
      : '100%'};
  ${p => (p.shadow ? 'box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16)' : '')};
  ${p => (p.halo ? 'box-shadow: 0 5px 8px 0 rgba(45, 219, 187, 0.41);' : '')};
  ${p => (p.bgColor ? `background-color: ${p.bgColor}` : '')}
  height: 50px;
  font-size: 16px;
  font-weight: 700;
  transition: all .3s;
  &.ant-btn-primary:hover:not(:disabled),
  &.ant-btn-primary:focus:not(:disabled) {
    ${p => (p.halo ? 'box-shadow: 0 7px 12px 0 rgba(45, 219, 187, 0.41);' : '')}
    ${p =>
      p.shadow ? 'box-shadow: 0 3px 6px 0 rgba(153, 153, 153, 0.41);' : ''}
  }

  &.inactive:disabled {
    border-color:  #999999;
    background-color:  #999999;
    filter: grayscale(1);
    -webkit-filter: grayscale(1);
    opacity: 1;
    color: white;
    ${p =>
      p.halo || p.shadow
        ? 'box-shadow: 0 3px 6px 0 rgba(153, 153, 153, 0.41);'
        : ''}

    span {
      opacity: 0.4;
    }
  }

  &.special {
    background-color: #9900A5;
    border-color: #9900A5;
    ${p => (p.halo ? 'box-shadow: 0 7px 12px 0 rgba(255, 102, 0, 0.4);' : '')}

    &.ant-btn-primary:hover:not(:disabled),
    &.ant-btn-primary:focus:not(:disabled) {
      ${p => (p.halo ? 'box-shadow: 0 7px 12px 0 rgba(255, 102, 0, 0.4);' : '')}
    }

    &.ant-btn-primary:hover,
    &.ant-btn-primary:focus {
      color: #fff;
      background-color: #C654BE;
      border-color: #C654BE;
    }

    &.ant-btn-primary:active,
    &.ant-btn-primary.active {
      color: #fff;
      background-color: #68076D;
      border-color: #68076D;
    }
  }
`;

export const StyledFormItem = styled(Form.Item)`
  &.ant-form-item {
    margin-bottom: 0;
  }

  .ant-form-explain {
    margin-top: 1px;
    font-size: 11px;
  }
`;

export const CardButton = styled(Button)`
  padding: 15px;
  width: 100%;
  height: auto;
  border: none;
  border-radius: 0;
  text-align: left;
  // box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.16);
  line-height: inherit;
  margin: 4px 0 0;

  &:last-of-type {
    margin-bottom: 40px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }
`;

export const TransactionCardActionButton = styled(Button)`
  width: 100%;
  height: 35px;
  border: none;
  border-top: 1px solid #d9dfec !important;
  border-radius: 0;
  text-align: center;
  background-color: #fff !important;
`;

export const TransactionCardTitle = styled.h1`
  width: 100%;
  height: 28px;
  color: #57d7dd;
  font-size: 24px;
  line-height: 1.21;
  letter-spacing: normal;
  font-weight: 400;
  font-family: 'Lato', 'Gensen Rounded M', 'Gensen Rounded', sans-serif;
  text-align: center;
`;

export const TransactionAdjustmentCard = styled.div`
  margin: 15px 0;
  background-color: #ffffff;
  padding: 15px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 6px 0px;
  .title {
    font-size: 20px;
    font-weight: normal;
    line-height: 1.2;

    .button-icon {
      color: #57d7dd;
      margin-left: 10px;
      cursor: pointer;
      line-height: 13px;
      font-size: 13px;
    }
  }
`;

export const AdjustmentNotificationDiv = styled.div`
  img {
    width: 45px;
    padding-bottom: 2px;
    margin: 0 6px;
  }

  .content {
    max-width: 400px;
    margin: auto;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.19;
    letter-spacing: normal;
    text-align: center;
    color: #707070;
    padding: 10px 0;
    span {
      color: #9900a5;
    }
  }
`;

export const AdjustmentWeightDiv = styled.div`
  display: flex;
  div {
    width: 50%;
    padding: 16px 0;
    color: #707070;
    font-weight: 300;
    position: relative;
    p {
      height: 15px;
      margin: 0;
      font-weight: 300;
    }

    .arrow-icon {
      font-size: 23px;
      color: #cccccc;
      right: 5%;
      position: absolute;
      top: 40%;
    }

    &:last-child {
      text-align: left;
      padding-left: 10%;
      .weight,
      .price {
        color: #9900a5;
      }
    }
  }
`;

export const Hr = styled.hr`
  border-top: 1px dashed #f5f5f5;
`;

export const StyledDiv = styled.div`
  font-size: 12px;
  padding: 7px 0;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const StyledTimeline = styled(Timeline)`
  .ant-timeline-item-tail,
  .ant-timeline-item-head,
  .ant-timeline-item-content {
    left: calc(50% - 50px);
  }

  .ant-timeline-item-head {
    background-color: #f5f5f5;
  }

  .ant-timeline-item-tail {
    margin-left: 4px;
  }

  .ant-timeline-item-content {
    margin: 0;
    top: -4px;
    padding-left: 18px;
    width: calc(100% - (50% - 50px));
    line-height: 1.2;
  }

  .ant-timeline-item-head-custom {
    margin-left: 5px;
    padding: 0;
  }
`;

export const ExpandButton = styled(Button)`
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 0;
  width: 18px;
  height: 18px;
  padding: 0;
  margin-right: 10px;

  span {
    font-size: 10px;
    line-height: 12px;
  }
`;

export const QuoteButton = styled(Button)`
  font-size: 0;

  span {
    font-size: 11px;
    font-weight: 700;
    line-height: 22px;
  }
`;

export const WrapperDiv = styled.div`
  position: relative;
  background: #fff;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  &:not(:first-of-type) {
    margin-top: 6px;
  }
`;

export const ShipmentRow = styled(Row)`
  font-size: 12px;
  padding: 7px 0;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const ChargeRow = styled(Row)`
  font-size: 12px;
  padding: 11px 0;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const ItemsRow = styled(Row)`
  font-size: 12px;
  padding: 15px 0;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const StyledSelect = styled(Select)`
  width: ${p =>
    p.width
      ? typeof p.width === 'number'
        ? `${p.width}px`
        : p.width
      : '100%'};

  .ant-select-selector {
    ${p => (p.curved ? 'border-radius: 50px !important;' : '')}
  }

  .ant-select-selection__rendered {
    margin-left: 14px;
    margin-right: 14px;
  }

  .ant-select-arrow {
    color: #57d7dd;
    right: 14px;
  }

  ${p =>
    p.item &&
    `
    &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      border-radius: 4px 0 0 4px;
    }

    &.ant-select-focused {
      position: relative;
      z-index: 1;
    }
  `}
`;

export const StyledCol = styled(Col)`
  ${props =>
    props.isPopup
      ? `
    width: 100%;
    padding-bottom: 100%;
    background-size: cover;
    background-position: center;
    position: relative;

    > div {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    @media (min-width: 768px) {
      width: 50%;
      padding-bottom: 50%;
    }
  `
      : `
    flex: ${props.flex ? props.flex : 1};
  `}
`;

export const StyledGoogleLogin = styled(GoogleLogin)`
  width: 100%;
  justify-content: center;

  & > span {
    font-weight: 700;
    font-size: 16px;
  }
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    max-width: 300px;
  }

  .ant-drawer-content {
    background-color: #fff;
  }

  .ant-drawer-body {
    height: 100%;
  }
`;

export const DownloadButton = styled(Button)`
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  height: 50px;
  background-color: #9900a5;
  border-color: #9900a5;

  &.ant-btn-primary:hover,
  &.ant-btn-primary:focus {
    color: #fff;
    background-color: #c654be;
    border-color: #c654be;
  }

  &.ant-btn-primary:active,
  &.ant-btn-primary.active {
    color: #fff;
    background-color: #68076d;
    border-color: #68076d;
  }
`;

export const StyledStep = styled(Steps.Step)`
  .ant-steps-item-tail,
  .ant-steps-item-icon {
    display: none;
  }

  .ant-steps-item-content {
    margin-top: 0;
    width: auto;
  }

  .ant-steps-item-title {
    font-size: 16px;
    font-weight: 700;
  }

  &.ant-steps-item-wait {
    .ant-steps-item-title {
      opacity: 0.46;
    }
  }

  &.ant-steps-item-finish {
    .ant-steps-item-title {
      opacity: 0.46;
    }
  }

  &.ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #57d7dd;
  }
`;

export const RemoveButton = styled(Button)`
  min-width: 0;
  width: ${props => (props.small ? '16px' : '20px')};
  height: ${props => (props.small ? '16px' : '20px')};
  font-size: 0;
  padding: 0;

  span {
    font-size: ${props => (props.small ? '9px' : '11px')};
    font-weight: 700;
    line-height: ${props => (props.small ? '14px' : '18px')};
  }
`;

export const StyledInputNumber = styled(InputNumber)`
  width: ${p => (p.fullWidth ? '100%' : 'auto')};

  .ant-input-number-input {
    width: 100%;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }

  &.ant-input-number-focused {
    position: relative;
    z-index: 1;
  }

  font-size: ${p =>
    p.fontSize
      ? typeof p.fontSize === 'number'
        ? `${p.fontSize}px`
        : p.fontSize
      : '14px'};
  ${p => (p.curved ? 'border-radius: 50px;' : '')}
`;

export const BigInputNumber = styled(InputNumber)`
  width: 75px;
  height: 50px;
  margin: 0 14px;

  .ant-input-number-input {
    text-align: center;
    font-weight: 700;
    width: 100%;
    height: 48px;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }
`;

export const ItemWrapper = styled.div`
  position: relative;
  padding: 0;
  background: #fff;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  &:not(:first-of-type) {
    margin-top: 3px;
  }
`;

export const ItemButton = styled(Button)`
  padding: 25px 15px;
  width: 100%;
  height: auto;
  border: none;
  border-radius: 0;
  text-align: left;
  box-shadow: none;
`;

export const StyledRadioGroup = styled(Radio.Group)`
  width: 100%;

  .ant-radio-wrapper {
    display: block;
    width: 100%;
  }

  .ant-radio {
    margin-right: 19px;
  }

  span.ant-radio + * {
    width: calc(100% - 35px);
    display: inline-block;
    padding-left: 0;
    padding-right: 0;
    vertical-align: middle;
  }
`;

export const StyledRadioGroupHorizontal = styled(Radio.Group)`
  width: 100%;

  .ant-radio-wrapper {
    display: inline-block;
    margin-right: 30px;
  }

  .ant-radio {
    margin-right: 12px;
  }

  span.ant-radio + * {
    width: calc(100% - 35px);
    display: inline-block;
    padding-left: 0;
    padding-right: 0;
    vertical-align: middle;
  }
`;

export const StyledVerticalDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    box-shadow: none !important;

    .ant-drawer-content {
      max-width: ${process.env.REACT_APP_MAX_WIDTH}px;
      box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.16);
      margin: 0 auto;

      .ant-drawer-wrapper-body {
        height: 100%;

        .ant-drawer-body {
          background-color: #f5f5f5;
          height: 100%;
          padding: 0;
        }
      }
    }
  }
`;

export const ConfirmDrawerDiv = styled(Drawer)`
  .ant-drawer-content-wrapper {
    box-shadow: none !important;

    .ant-drawer-title {
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      color: #44474a;
    }
    .ant-drawer-content {
      max-width: ${process.env.REACT_APP_MAX_WIDTH}px;
      box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.16);
      margin: 0 auto;
      padding: 10px;

      .ant-drawer-wrapper-body {
        height: 100%;

        .ant-drawer-body {
          background-color: #fff;
          height: 100%;
          padding: 0;
          display: flex;
          flex-direction: column;
          .children {
            flex: auto;
            margin: auto;
            width: 90%;
            padding: 25px 0;
            height: 70%;
          }
          .btn-group {
            margin: auto;
            width: 90%;
            flex: auto;
          }
        }
      }
    }
  }
`;

export const AddressDisplay = styled(Button)`
  margin-top: 8px;
  padding: 15px;
  width: 100%;
  height: auto;
  border: none;
  border-radius: 0;
  text-align: left;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
  white-space: initial;
  pointer-events: none;
`;

export const AddressButton = styled(Button)`
  margin-top: 8px;
  padding: 15px;
  width: 100%;
  height: auto;
  border: none;
  border-radius: 0;
  text-align: left;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
  white-space: initial;
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  ${p => (p.curved ? 'border-radius: 50px;' : '')}
`;

export const LoginDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    max-width: ${process.env.REACT_APP_MAX_WIDTH}px;

    .ant-drawer-content {
      background-color: #fafafa;
    }
  }
`;

export const BoxDrawer = styled(Drawer)`
  font-size: 40px;

  .ant-drawer-content-wrapper {
    max-width: ${process.env.REACT_APP_MAX_WIDTH}px;
  }

  .ant-drawer-wrapper-body {
    display: flex;
    flex-direction: column;

    .ant-drawer-header {
      flex: 0 1 auto;
    }

    .ant-drawer-body {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      padding: 15px;
    }
  }
`;

export const StyledRow = styled(Row)`
  padding: 10px 0;
`;

export const ParcelName = styled.span`
  font-weight: 700;
  color: #2c2c2e;
`;

export const ParcelDescription = styled.span`
  font-size: 10px;
  color: #2c2c2e;
`;

export const ResponsiveDesktopDiv = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const ResponsiveMobileDiv = styled.div`
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const PureButton = styled.button`
  font-weight: bold;
  color: #57d7dd;
  background-color: #fff;
  border: none;
  ${p => (p.noMargin ? '' : 'margin-top: 10px;')}
  cursor: pointer;
  outline: 0;
  font-size: ${p =>
    p.fontSize && typeof p.fontSize === 'number' ? `${p.fontSize}px` : '12px'};
  line-height: ${p =>
    p.lineHeight && typeof p.lineHeight === 'number'
      ? `${p.lineHeight}px`
      : '10px'};

  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  &:hover {
    opacity: 0.7;
  }
`;

export const StyledPopup = styled.div`
  padding: 20px 20px 0;
  font-size: 12px;

  .title {
    font-size: 24px;
    font-weight: 700;
    color: #57d7dd;
    text-align: center;
    padding: 8px 0;
  }

  .subtitle {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    padding: 4px 0;
  }

  img {
    width: 100%;
  }
`;

export const StyledReschedulePopup = styled.div`
  padding: 20px 20px 0;
  font-size: 12px;

  .title {
    font-size: 24px;
    font-weight: 700;
    color: #57d7dd;
    text-align: center;
    padding: 8px 0;
  }

  .mini-title {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    color: #57d7dd;
    padding: 4px 0;
  }

  .description {
    text-align: center;
    color: #2c2c2e;
    font-size: 12px;
    padding: 4px 0;
  }
`;

export const StyledCampaignDetails = styled.div`
  padding: 20px 20px 0;
  font-size: 12px;
  font-weight: 700;
  text-align: center;

  .title {
    font-size: 24px;
    padding: 8px 0;
  }

  .name {
    color: #57d7dd;
    font-size: 18px;
    padding: 4px 0;
  }

  .campaign-img {
    width: 100%;
    padding: 20px 40px;
  }

  .campaign-icon {
    height: 40px;
    padding: 0 120px;
  }
`;

export const Overlay = styled.div`
  opacity: 1;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.45);
  -webkit-transform: translate3d(0, 0, 0);
  z-index: ${p => (p.zIndex ? p.zIndex : 1000)};
`;

export const StyledCampaignPopupContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
  transition: 200ms ease-in;
  max-width: 400px;

  > div {
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
  }

  &:nth-child(1) {
    opacity: 1;
  }

  &:nth-child(2) {
    .body-div {
      overflow: auto;
    }
  }

  &:nth-child(3) {
    transform: translate(-50%, -50%) scale(0.95);
    left: calc(50% + 20px);
    opacity: 0.9;
  }

  &:nth-child(4) {
    transform: translate(-50%, -50%) scale(0.9);
    left: calc(50% + 40px);
    opacity: 0.8;
  }

  &:nth-child(5) {
    transform: translate(-50%, -50%) scale(0.85);
    left: calc(50% + 60px);
    opacity: 0;
  }

  &:nth-child(n + 6) {
    display: none;
  }

  @media (min-width: 768px) {
    &:nth-child(3) {
      left: calc(50% + 35px);
    }

    &:nth-child(4) {
      left: calc(50% + 70px);
    }

    &:nth-child(5) {
      transform: translate(-50%, -50%) scale(0.85);
      left: calc(50% + 105px);
    }
  }
`;

export const PopupBody = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
  transition: 200ms ease-in;
  max-width: 400px;

  > div {
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
  }

  &:nth-child(1) {
    opacity: 0;
    left: 0;
    pointer-events: none;
  }

  &:nth-child(2) {
    .body-div {
      overflow: auto;
    }
  }

  &:nth-child(3) {
    transform: translate(-50%, -50%) scale(0.95);
    left: calc(50% + 20px);
    opacity: 0.9;
  }

  &:nth-child(4) {
    transform: translate(-50%, -50%) scale(0.9);
    left: calc(50% + 40px);
    opacity: 0.8;
  }

  &:nth-child(5) {
    transform: translate(-50%, -50%) scale(0.85);
    left: calc(50% + 60px);
    opacity: 0;
  }

  &:nth-child(n + 6) {
    display: none;
  }

  @media (min-width: 768px) {
    &:nth-child(3) {
      left: calc(50% + 35px);
    }

    &:nth-child(4) {
      left: calc(50% + 70px);
    }

    &:nth-child(5) {
      transform: translate(-50%, -50%) scale(0.85);
      left: calc(50% + 105px);
    }
  }

  &.post {
    max-width: 400px;
    width: 80%;

    @media (min-width: 768px) {
      max-width: 800px;
      min-width: 768px;
    }

    &:nth-child(1) {
      opacity: 0;
      left: 0;
      pointer-events: none;
    }
  }
`;

export const MarkdownDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .body-div {
    flex: 1 1 auto;
    padding: 20px;

    > div {
      display: table;
      width: 100%;
      height: 100%;

      > div {
        display: table-cell;
        text-align: center;
        vertical-align: middle;

        .title {
          font-size: 24px;
          color: #57d7dd;
          font-weight: 700;
        }
      }
    }
  }

  .button-div {
    flex: 0 1 auto;
    text-align: center;
    padding: 0 20px 20px;
  }
`;

export const PushUpBodyDiv = styled.div`
  margin: auto;
  width: 100%;
  height: 50%;
  max-width: 500px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 15px;
  h1 {
    font-family: 'Lato', 'Gensen Rounded M', 'Gensen Rounded', sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #57d7dd;
    margin: 15px 0;
  }
  .subTitle {
    font-size: 16px;
    line-height: 1.19;
    letter-spacing: normal;
    color: #707070;
    padding: 0 10px;
  }
  .actions-btn-group {
    margin-top: 20px;
  }
  img {
    width: 76px;
    height: 76px;
    object-fit: contain;
  }
`;

export const NoWrapText = styled.span`
  white-space: nowrap;
`;
